import { Flex, StackScreen } from '@banhala/ui-kit';
import { useHandleBackPressed } from 'shared/src/hooks';
import { useGetCommonParams, useReportTTFD } from '../../hooks';
import {
  ScreensResult,
  ScreensHeader,
  ScreensAnalyticsProvider,
} from '../../components';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { DropdownNavigatorPanel } from '../../components/DropdownNavigator';
import { FilterListAtomicProvider } from 'shared/src/component';
import { bridge } from 'shared/src/utils';
import { useCallback, useState } from 'react';
import type { ScreensMetaResponse } from 'shared/src/api';

export const Screens = () => {
  const { screenName } = useGetCommonParams();
  const { showBackButton, onPressBack } = useHandleBackPressed();
  const [title, setTitle] = useState<string | undefined>(undefined);
  const [dropdownNavigator, setDropdownNavigator] = useState<
    ScreensMetaResponse['screen']['dropdown_navigator'] | null
  >(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_DROPDOWN_HEADER',
      analytics: { SCREEN: screenName, IS_UNROLL: !isDropdownOpen },
    });
    setIsDropdownOpen(prev => !prev);
  }, [isDropdownOpen, screenName]);

  const closeDropdown = useCallback(() => {
    setIsDropdownOpen(false);
  }, []);

  useReportTTFD();

  return (
    <ScreensAnalyticsProvider>
      <StackScreen
        hideBackButton={!showBackButton}
        onPressBack={onPressBack}
        hideHeader
        backButtonTestID={'뒤로가기버튼'}
      >
        <Flex flex={1}>
          <ScreensHeader
            title={title}
            dropdownNavigator={dropdownNavigator}
            isDropdownOpen={isDropdownOpen}
            onToggleDropdown={toggleDropdown}
            showBackButton={showBackButton}
            onPressBack={onPressBack}
            rightIcons={[
              <SearchIcon key="search" />,
              <CartIcon key="cart" />,
            ]}
          />
          <Flex flex={1} position="relative">
            <FilterListAtomicProvider>
              <ScreensResult
                setTitle={setTitle}
                setDropdownNavigator={setDropdownNavigator}
              />
              {isDropdownOpen && dropdownNavigator && (
                <Flex position="absolute" top={0} left={0} right={0} bottom={0}>
                  <DropdownNavigatorPanel
                    title={title ?? ''}
                    dropdownNavigator={dropdownNavigator}
                    onClose={closeDropdown}
                  />
                </Flex>
              )}
            </FilterListAtomicProvider>
          </Flex>
        </Flex>
      </StackScreen>
    </ScreensAnalyticsProvider>
  );
};
